export default {"src":"/_next/static/media/calendar-icon.b0f9ceff.svg","height":1600,"width":1600};